import React, { PureComponent } from 'react';
import Translate from '@client/components/shared/translation/Translate';
import CSSModules from 'react-css-modules';

import styles from './radioLabel.scss';

class RadioLabel extends PureComponent {
    render() {
        return (
            <span styleName="radio-label">
                <Translate message={this.props.label} />
            </span>
        );
    }
}

export default CSSModules(RadioLabel, styles, { allowMultiple: true });
